import PostApprovePageView from "../../components/community/post_approve_pageview";

const PendingPostsScreen = () => {
    return (
        <PostApprovePageView isPost={true} />
    )
}

export default PendingPostsScreen;